import { Restriction as ArrayRestriction } from "./Restriction";
export var Array;
(function (Array) {
    Array.Restriction = ArrayRestriction;
})(Array || (Array = {}));
//# sourceMappingURL=index.js.map